import React, { ReactElement } from 'react';
import { SearchInputPropType } from './types';
import './style.css';

const SearchInput = (props: SearchInputPropType) => {
  const {
    inputRef,
    defaultValue,
    label,
    placeholder,
    error,
    value,
    onChange,
    disabled,
    required,
    isActive,
    onClickInput,
    onBlur,
  } = props;

  const _handleOnInputTextChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (disabled) {
      return;
    };

    const inputText = event.target.value;

    onChange && onChange(inputText);
  }

  const _renderInput = (): ReactElement => {
    return <div
      className={`MuiOutlinedInput-input search-input-wrapper ${!disabled && "cursor-pointer"}  ${error && "ms-border-error"
        } ${isActive && "ms-border-selected"} ${disabled && 'search-input-wrapper-disabled'}`}
      onClick={disabled ? () => { } : () => onClickInput && onClickInput()}
      ref={inputRef}
    >
      <input
        type="text"
        readOnly={false}
        className="checbox-input ellipsis search-input"
        defaultValue={defaultValue}
        value={value}
        disabled={disabled}
        placeholder={placeholder}
        required={required}
        onChange={_handleOnInputTextChange}
        onBlur={onBlur}
        onClick={disabled ? () => { } : () => onClickInput && onClickInput()}
        data-testid="search-input"
      />
      <img
        //up and down motion of the arrow
        className={isActive ? "ms-dropdown-arrow ms-arrow-rotate" : "ms-dropdown-arrow"}
        src="/self-serve/ic_dropdown@3x.png"
        alt=""
        height={7}
        width={11}
      />
    </div>
  }

  return (<div>
    {_renderInput()}
  </div>);
}

export default SearchInput;